<div
  [ngClass]="{hasBanner: hasBanner || hasPromoBanner, hasAccessibilityLink: showAccessibilityLink, isWebview: webview}"
>
  <ng-container *ngIf="!webview">
    <vc-progress-bar></vc-progress-bar>
    <div *ngIf="showAccessibilityLink" class="accessibilityTopLink">
      <a
        href="#"
        class="accessibilityTopLink__link UsableNetAssistive"
        onclick="return enableUsableNetAssistive()"
        (click)="sendAccessibilityTracking()"
        i18n="@@ACCESSIBILITY.LINK.ENABLE"
      >
        Enable Accessibility
      </a>
    </div>
    <vc-smart-app-banner [osList]="os"></vc-smart-app-banner>
    <vc-promo-banner
      *ngIf="!isHomePage && !isLandingPage && !isEditoPage"
      [isHomePage]="isHomePage"
      (bannerLoaded)="setHasPromoBanner($event)"
    ></vc-promo-banner>
    <vc-svg-logo-vestiaire-collective></vc-svg-logo-vestiaire-collective>
    <vc-header [hasBanner]="hasBanner && (isHomePage || isLandingPage || isEditoPage)" class="isSticky"></vc-header>
  </ng-container>
  <main><router-outlet (activate)="onActivate()"></router-outlet></main>
  <ng-container *ngIf="!webview">
    <vc-footer
      [isSelectedPage]="isHomePage"
      [showAccessibilityLink]="showAccessibilityLink"
      [pageType]="pageType"
      [i18nvalue]="i18nvalue"
    ></vc-footer>
  </ng-container>
</div>
